/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";

/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";
import FormDatePickerFields from "../../../../../../components/finalForms/formFields/FormDatePickerField";
import CardSection from "../../../../../../components/ui/card/CardSection";

/** Services */
import ToastService from "../../../../../../services/toastService/ToastService";
import SwalAlert from "../../../../../../services/swalService/SwalService";

/** RTK Query */
import { useAddContractDepartmentsMutation, useContractDepartmentRemoveMutation, useContractDepartmentUpdateCostFromScopesMutation, useGetAllContractScopesMutation, useLazyGetcontractDepartmentInvoiceScheduleQuery, useLazyGetContractDepartmentsAvailableQuery, useLazyGetContractDepartmentsQuery, useLazyInvoiceExistsForDepartmentQuery } from "../../../../../../app/services/contractAPI";

/**Context */
import { ContractContext } from "../../../../../../utils/context/ContractContext";

/** Component */
import EditDepartment from "./features/ContractEditDepartment";

const Departments = () => {
  const { contractData, contractId } = useContext(ContractContext);
  const [contractDepartmentsData, setContractDepartmentsData] = useState([]);
  const [contractDepartmentsAvailableData, setContractDepartmentsAvailableData] = useState([]);
  const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);
  const [effectiveDate, setEffectiveDate] = useState(new Date());
  const [rowData, setRowData] = useState(null);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isEditModelOpen, setIsEditModelOpen] = useState(false);
  const [invoiceExists, setInvoiceExists] = useState();
  const { confirm, warning } = SwalAlert();

  const [getContractDepartmentsAvailable, {
    isFetching: isContractDepartmentsAvailableFetching,
    isSuccess: isContractDepartmentsAvailableFetched,
    data: ContractDepartmentsAvailableData,
  },] = useLazyGetContractDepartmentsAvailableQuery();

  const [getContractDepartments, {
    isFetching: isContractDepartmentsFetching,
    isSuccess: isContractDepartmentsFetched,
    data: ContractDepartmentsData,
  },] = useLazyGetContractDepartmentsQuery();

  const [addContractDepartments, {
    isSuccess: isContractDepartmentsAdded,
    data: ContractDepartmentsaddData,
  },] = useAddContractDepartmentsMutation();

  const [invoiceExistsForDepartment, {
    isFetching: isInvoiceExistsForDepartmentFetching,
    isSuccess: isInvoiceExistsForDepartmentFetched,
    data: InvoiceExistsForDepartmentData
  }] = useLazyInvoiceExistsForDepartmentQuery();

  const [getAllContractScopes] = useGetAllContractScopesMutation();

  const [getcontractDepartmentInvoiceSchedule] = useLazyGetcontractDepartmentInvoiceScheduleQuery();

  const [contractDepartmentUpdateCostFromScopes] = useContractDepartmentUpdateCostFromScopesMutation();

  const [contractDepartmentRemove, {
    isSuccess: iscontractDepartmentRemoveFetching,
    data: deletecontractDepartmentData
  }] = useContractDepartmentRemoveMutation();

  useEffect(() => {
    if (contractId) {
      getContractDepartmentsAvailable(contractId);
      getContractDepartments({ plContractDepartmentKey: 0, plContractKey: contractId, plClientKey: 0 });
    }
  }, [contractId]);


  useEffect(() => {
    if (!isContractDepartmentsAvailableFetching && isContractDepartmentsAvailableFetched && ContractDepartmentsAvailableData) {
      if (ContractDepartmentsAvailableData) {
        setContractDepartmentsAvailableData(ContractDepartmentsAvailableData);
      }
    }
  }, [isContractDepartmentsAvailableFetching, isContractDepartmentsAvailableFetched, ContractDepartmentsAvailableData])

  useEffect(() => {
    if (!isContractDepartmentsFetching && isContractDepartmentsFetched && ContractDepartmentsData) {
      if (ContractDepartmentsData) {
        setContractDepartmentsData(ContractDepartmentsData);
      }
    }
  }, [isContractDepartmentsFetching, isContractDepartmentsFetched, ContractDepartmentsAvailableData])

  useEffect(() => {
    if (!isInvoiceExistsForDepartmentFetching && isInvoiceExistsForDepartmentFetched && InvoiceExistsForDepartmentData) {
      setInvoiceExists(InvoiceExistsForDepartmentData?.bInvoiceExists);
    }
  }, [isInvoiceExistsForDepartmentFetching, isInvoiceExistsForDepartmentFetched, InvoiceExistsForDepartmentData])

  useEffect(() => {
    if (isContractDepartmentsAdded && ContractDepartmentsaddData) {
      if (ContractDepartmentsaddData) {
        contractDepartmentUpdateCostFromScopes({ plContractKey: Number(contractId), plDepartmentKey: rowData?.lDepartmentKey });
        ToastService.success(ContractDepartmentsaddData?.errorMessage);
        handleCloseModel();
      }
    }
  }, [isContractDepartmentsAdded, ContractDepartmentsaddData]);

  useEffect(() => {
    if (iscontractDepartmentRemoveFetching && deletecontractDepartmentData) {
      if(deletecontractDepartmentData?.errorMessage){
        ToastService.success(deletecontractDepartmentData?.errorMessage);
        handleCloseModel();
      }
    }
  }, [iscontractDepartmentRemoveFetching, deletecontractDepartmentData])

  const handleCloseModel = () => {
    setIsModelOpen(false);
    setIsEditModelOpen(false);
    getContractDepartmentsAvailable(contractId);
    setSelectedCheckboxRows([]);
    setEffectiveDate(new Date());
    getContractDepartments({ plContractDepartmentKey: 0, plContractKey: contractId, plClientKey: 0 });
  };
  
  const handleAddRowData = (rowData) => {
    setIsModelOpen(true);
    setRowData(rowData);

  };
  const handleEditRowData = (rowData) => {
    setIsEditModelOpen(true);
    setRowData(rowData);
  }

  const handaleSave = () => {
    if (!effectiveDate) {
      ToastService.error("Effective Date  is required");
      return;
    }
    const request = {
      plContractKey: contractId,
      psDepartmentKeys: String(rowData?.lDepartmentKey),
      pdtEffectiveDate: effectiveDate,
      pdtEndDate: new Date(effectiveDate.getFullYear() + 1, 0, 0),
    }
    addContractDepartments(request);
  }

  const handleAssignClick = () => {
    if (!effectiveDate) {
      ToastService.error("Effective Date is required");
      return;
    }
    if (selectedCheckboxRows && selectedCheckboxRows.length > 0) {
      const departmentKeys = selectedCheckboxRows.map(row => row.lDepartmentKey).join(',');
      const request = {
        plContractKey: contractId,
        psDepartmentKeys: departmentKeys,
        pdtEffectiveDate: effectiveDate,
        pdtEndDate: new Date(new Date().getFullYear() + 1, 0, 0),
      }
      addContractDepartments(request);
    } else {
      ToastService.error("Please select at least one department to assign.");
    }
  }

  const handleDateChange = (dataField, updatedData) => {
    setEffectiveDate(updatedData);
  }

  const handleDeleteRow = async (rowData) => {
    let bConfirm = true;

    await invoiceExistsForDepartment(rowData?.lContractDepartmentKey);

    if (invoiceExists === true) {
      warning("This department cannot be removed because it has invoices associated with it.", "Cannot Remove Department");
      return;
    }

    const terminationDate = contractData?.dtDateTermination;
    const today = new Date();
    const dtAsOfDate = terminationDate === null ? today :
      new Date(terminationDate) > today ? today :
        new Date(terminationDate);

    const req = {
      plContractKey: contractId,
      pbIncludeInactive: true,
      pdtAsOfDate: dtAsOfDate,
      plScopeKey: 0,
      pbExcludeCPO: false,
      pbShowFutureScopes: true
    };

    const scopes = await getAllContractScopes(req).unwrap();

    if (scopes && scopes.length > 0) {
      const confirmed = await confirm(
        "WARNING:  There are scopes assigned to this contract that belong to this department.  If you remove this department, those scopes will also be removed. Are you sure you want to continue?",
        "Remove Department",
        "Yes",
        "No"
      );

      if (!confirmed) return;
    }

    const schedules = await getcontractDepartmentInvoiceSchedule({
      plContractKey: contractId,
      plDepartmentKey: rowData.lDepartmentKey
    }).unwrap();

    if (schedules && schedules.length > 0) {
      const confirmed = await confirm(
        "WARNING: This department has an invoice schedule. If you remove it the schedule will be removed as well. Are you sure you want to continue?",
        "Remove Department",
        "Yes",
        "No"
      );

      if (!confirmed) return;
    }

    if (bConfirm) {
      const finalConfirm = await confirm(
        "Are you sure you want to remove this department?",
        "Remove Department?",
        "Delete",
        "Cancel"
      );
      if (!finalConfirm) return;
      contractDepartmentRemove(rowData?.lContractDepartmentKey)
    }
  };


  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: "Add",
        command: () => handleAddRowData(row),
      },
    ];
  };

  const getCtxMenuItems1 = (row) => {
    if (!row) return [];

    return [
      {
        label: "Edit",
        //  icon: 'pi pi-plus',
        command: () => handleEditRowData(row),
      },
      {
        label: "Remove",
        //icon: 'pi pi-pen-to-square',
        command: () => handleDeleteRow(row)
      },
    ];
  }

  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection
            cardTitle="Assigned Departments"
          >
            <MolGrid
              value={contractDepartmentsData}
              grouping
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems1}
            >
              <Column field="client" header="Client" grouping sortable />
              <Column field="department" header="Department" bodyStyle={{ textAlign: "Center" }} grouping sortable />
              <Column field="sServiceLocation" header="Service Location" bodyStyle={{ textAlign: "Center" }} grouping sortable />
              <Column field="effectiveDate" header="Effective Date" colType="datetime" format="mm/dd/yyyy" bodyStyle={{ textAlign: "Center" }} grouping sortable />
              <Column field="endDate" header="End Date" colType="datetime" format="mm/dd/yyyy" bodyStyle={{ textAlign: "Center" }} grouping sortable />
              <Column field="nCost" header="Cost" bodyStyle={{ textAlign: "Right" }} grouping sortable />
              <Column field="sNonBillable" header="Non-Billable" bodyStyle={{ textAlign: "Center" }} grouping sortable />
            </MolGrid>
          </CardSection>
        </div>

        <div className="center-btn">
          <Buttons
            isIcon={true}
            iconClass="bxs:up-arrow"
            onClick={() => setIsModelOpen(true)}
            buttonTypeClassName="btn blue-btn"
            titleText="Assign Selected Items"
            isDisable={selectedCheckboxRows.length === 0}
          // isLoading={isDeleting}
          />
        </div>
        <div className="scrollable-grid col-12 available-department">
          <CardSection
            cardTitle="Available Departments"
          >
            <MolGrid
              grouping
              value={contractDepartmentsAvailableData}
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems}
              selection={selectedCheckboxRows}
              onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
              dataKey="lDepartmentKey"
            >
              <Column selectionMode="multiple" bodyStyle={{ textAlign: "center" }} />
              <Column field="client" header="Client" grouping sortable />
              <Column field="department" header="Department" bodyStyle={{ textAlign: "Center" }} grouping sortable />
              <Column field="sServiceLocation" header="Service Location" grouping sortable bodyStyle={{ textAlign: "center" }} />
            </MolGrid>
          </CardSection>
        </div>
        <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={"Add Department"}
          contentClass="content-30"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
          className="add-contract-department"
        >
          <FormDatePickerFields
            labelName={"Effective Date"}
            dataField={"effectiveDate"}
            fieldSetting={{ placeholder: "Select Effective Date" }}
            value={effectiveDate}
            isRequired={true}
            onChange={handleDateChange}
          />
          <div className="d-flex justify-content-center button-submit mt-3">
            <Buttons
              buttonText="Save"
              buttonTypeClassName="btn blue-btn w-full"
              onClick={selectedCheckboxRows && selectedCheckboxRows.length > 0 ? handleAssignClick : handaleSave}
            // isDisable={!isEditContract}
            />
            <Buttons
              buttonText="Cancel"
              buttonTypeClassName="btn secondary-btn ml-4"
              onClick={handleCloseModel}
            />
          </div>
        </CustomCenterModel>
      </div>
      <div>
        <CustomCenterModel
          isOpen={isEditModelOpen}
          useCustomBg={true}
          modalTitle={"Edit Contract Department"}
          contentClass="content-30"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
          className="add-contract-department"
        >
          <EditDepartment
            rowData={rowData}
            contractId={contractId}
            onClose={handleCloseModel} />
        </CustomCenterModel>
      </div>
    </>
  );
};
export default Departments;
